// extracted by mini-css-extract-plugin
export default {"main":"Oaa-z"};